import { useCallback } from 'react';
import { useCommunityConfiguration } from '../useCommunityConfiguration';

export const useFeatureGuard = () => {
  const { configuration, loading, error } = useCommunityConfiguration();

  const communityHasFeatures = useCallback(
    (...features: string[]): boolean => {
      if (!configuration) return false;

      return features.every((feature) =>
        configuration?.featureToggles?.some(
          (featureToggle) =>
            featureToggle.feature === feature && featureToggle.toggled,
        ),
      );
    },
    [configuration],
  );

  return {
    featureToggles: configuration?.featureToggles || [],
    communityHasFeatures,
    loading,
    error: error?.message,
  };
};
